export function formatOptimizationCost(amount: number): string {
  const cents = Math.round(amount * 100);
  const formatted = (Math.abs(cents) / 100).toFixed(2);
  return cents < 0 ? `-$${formatted}` : `$${formatted}`;
}

export function formatShareOfDesignTotal(fraction: number): string {
  return `${Math.round(fraction * 100)}%`;
}
